/* eslint-disable no-param-reassign */
import qs from 'qs'
import { useUserStore } from '@/store'
import { useLoginStore } from '@/store/modules/login'
import { platform } from '@/utils/platform'
import { getEnvBaseUrl, showModal } from '@/utils'
import { setStorage } from '@/utils/storage'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
  /** 是否显示loading */
  showLoading?: boolean
  /** loading提示文本 */
  loadingText?: string
  /** 是否需要token */
  needToken?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

const tg = typeof window !== 'undefined' && window.Telegram?.WebApp ? window.Telegram.WebApp : {}

const user = tg?.initDataUnsafe?.user ?? null

if (tg) {
  setStorage('tg', tg)
} else {
  showModal('⚠️ TG Error', {
    showCancel: false,
  })
  throw new Error('⚠️ TG Error')
  // 可选：给用户提示，引导使用正确入口
}

// 请求基准地址
const baseUrl = getEnvBaseUrl()

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = qs.stringify(options.query)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      if (JSON.parse(__VITE_APP_PROXY__)) {
        // 啥都不需要做
      } else {
        options.url = baseUrl + options.url
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      options.url = baseUrl + options.url
      // #endif
    }

    // 1. 请求超时
    options.timeout = 20000

    // 2. 添加请求头
    options.header = {
      platform,
      ...options.header,
    }
    // console.log('options', options)

    // 3. 处理token
    const userStore = useUserStore()
    const loginStore = useLoginStore()
    const token = `${userStore.token.token}`

    // 判断是否需要token（白名单接口不需要token）
    const whiteList = ['/captchaImage/login', '/captchaImage']
    // needToken默认为true，只有明确设置为false或在白名单中的接口才不需要token
    const needToken =
      options.needToken !== false && !whiteList.some((path) => options.url.includes(path))
    // 请求头添加多语言
    const locale = uni.getLocale()
    console.log('locale', locale)
    switch (locale) {
      case 'zh-Hans':
        options.header['Accept-Language'] = 'zh'
        break
      case 'en':
        options.header['Accept-Language'] = 'en'
        break
    }
    if (needToken) {
      if (!token) {
        if (user) {
          // tg 登录
          console.log('tg 登录')

          userStore.tgLogin().then((res) => {
            console.log('res', res)
            if (res.code === 0) {
              uni.request(options)
            } else {
              showModal(res.msg)
            }
          })
        } else {
          // 普通登录
          // 显示登录弹窗
          loginStore.showLogin('', () => {
            // 登录成功后重新发起请求
            uni.request(options)
          })
        }
        return false
      }
      // 添加token到请求头
      options.header['x-token'] = `${token}`
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
